import { useEffect, useState } from "react";
import DashboardHeader from "@/components/DashboardHeader";
import BackButton from "@/components/BackButton";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2, FileCheck2, ClipboardCheck, Clock, Inbox } from "lucide-react";
import { adminGradingStats } from "@/lib/grading";

function Stat({ label, value, icon: Icon, testid }) {
  return (
    <Card className="border-stone-200" data-testid={testid}>
      <CardContent className="py-5 flex items-center gap-3">
        <div className="rounded-md bg-amber-50 p-2.5">
          <Icon className="h-5 w-5 text-amber-700" />
        </div>
        <div>
          <div className="text-2xl font-semibold leading-none">{value}</div>
          <div className="text-xs text-stone-500 mt-0.5">{label}</div>
        </div>
      </CardContent>
    </Card>
  );
}

export default function AdminGrading() {
  const [s, setS] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    adminGradingStats()
      .then(setS)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div
      className="min-h-screen bg-stone-50 text-stone-900"
      data-testid="admin-grading"
    >
      <DashboardHeader subtitle="Admin · Grading overview" />
      <main className="mx-auto max-w-5xl px-6 py-6 space-y-6">
        <BackButton to="/admin" />
        <div>
          <h1 className="text-2xl font-semibold">Grading overview</h1>
          <p className="text-sm text-stone-500">
            Snapshot of pending homework, pending tests, and teacher turnaround.
          </p>
        </div>
        {loading || !s ? (
          <Loader2 className="h-5 w-5 animate-spin text-stone-400" />
        ) : (
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            <Stat
              label="Pending homework"
              value={s.pending_homework}
              icon={FileCheck2}
              testid="stat-pending-homework"
            />
            <Stat
              label="Pending tests"
              value={s.pending_tests}
              icon={ClipboardCheck}
              testid="stat-pending-tests"
            />
            <Stat
              label="Graded this week"
              value={s.graded_this_week}
              icon={Inbox}
              testid="stat-graded-week"
            />
            <Stat
              label="Avg turnaround"
              value={
                s.avg_grade_turnaround_hours != null
                  ? `${s.avg_grade_turnaround_hours} h`
                  : "—"
              }
              icon={Clock}
              testid="stat-turnaround"
            />
          </div>
        )}
      </main>
    </div>
  );
}
